/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Loader2, CheckCircle2, XCircle, Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

export const statusMeta = {
  pending:    { label: 'In attesa',   cls: 'bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/30',   icon: Clock },
  accepted:   { label: 'Accettata',   cls: 'bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/30',       icon: CheckCircle2 },
  in_review:  { label: 'In esame',    cls: 'bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/30',       icon: Loader2 },
  responded:  { label: 'Risposta',    cls: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/30', icon: CheckCircle2 },
  declined:   { label: 'Rifiutata',   cls: 'bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/30',           icon: XCircle },
  cancelled:  { label: 'Annullata',   cls: 'bg-muted text-muted-foreground border-border',                             icon: XCircle },
};

export const urgencyMeta = {
  low:    { label: 'Bassa',  cls: 'bg-muted text-muted-foreground' },
  normal: { label: 'Normale', cls: 'bg-blue-500/10 text-blue-700 dark:text-blue-300' },
  high:   { label: 'Alta',   cls: 'bg-orange-500/10 text-orange-700 dark:text-orange-300' },
};


export const StatusBadge = ({ status }) => {
  const m = statusMeta[status] || statusMeta.pending;
  const Icon = m.icon;
  return <Badge variant="outline" className={cn('gap-1', m.cls)}><Icon className="h-3 w-3" />{m.label}</Badge>;
};
